module.exports = __webpack_public_path__ + "static/media/mz.9a595472.svg";